import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServicioFiltersService {

  private FILTER_URL = '';

  constructor(private http: HttpClient) { }

  public init() {
    this.FILTER_URL = environment.API_FILTERS;
  }

  public getSedesFilterRequest(code: string, username: string) {
    this.init();
    const URL = `${this.FILTER_URL}/sedes/filter-username?code-parameter=${code}&username-parameter=${username}`;
    const HTTP_HEADER = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.get( URL, { headers: HTTP_HEADER });
  }

}
